class SpecializedProductDelivery extends HTMLElement {
  connectedCallback() {
    this.postalOutput = this.querySelector('[data-specialized-product-postal]');
    this.changeButton = this.querySelector('[data-specialized-change-postal]');
    this.handlePostalChange = this.handlePostalChange.bind(this);
    this.handleChangeClick = this.handleChangeClick.bind(this);

    this.updatePostalCode(this.readPostalCode());
    document.addEventListener('multibike:postal-code-change', this.handlePostalChange);
    this.changeButton?.addEventListener('click', this.handleChangeClick);
  }

  disconnectedCallback() {
    document.removeEventListener('multibike:postal-code-change', this.handlePostalChange);
    this.changeButton?.removeEventListener('click', this.handleChangeClick);
  }

  handlePostalChange(event) {
    this.updatePostalCode(event.detail?.postalCode || '');
  }

  handleChangeClick() {
    const locationToggle = document.querySelector('[data-sp-location-toggle]');
    if (!locationToggle) return;

    locationToggle.click();
    document.querySelector('specialized-utility-bar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  readPostalCode() {
    try {
      return localStorage.getItem(this.dataset.storageKey || 'multibike-postal-code') || '';
    } catch {
      return '';
    }
  }

  updatePostalCode(postalCode) {
    if (!this.postalOutput) return;
    const digits = String(postalCode).replace(/\D/g, '').slice(0, 8);
    this.postalOutput.textContent = digits.length === 8
      ? `Entregar em ${digits.slice(0, 5)}-${digits.slice(5)}`
      : (this.dataset.emptyLabel || 'Informe seu CEP');
  }
}

if (!customElements.get('specialized-product-delivery')) {
  customElements.define('specialized-product-delivery', SpecializedProductDelivery);
}
